import { StorageReportEntry, StorageSummaryDto } from '@billing/app/api'
import StorageReportMode from '@billing/app/models/storage-report-mode.enum'
import exportService from '@billing/services/ExportService'
import { Dayjs } from 'dayjs'
import _ from 'lodash'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'

export class StorageReportUIStore {
  storageReportMode?: StorageReportMode

  from?: Dayjs
  to?: Dayjs
  summary: StorageSummaryDto[] = []

  storageEntries: StorageReportEntry[] = []
  isLoading = false
  handleDownload?: () => void

  constructor() {
    makeObservable(this, {
      storageReportMode: observable,
      from: observable,
      to: observable,
      summary: observable,
      storageEntries: observable,
      isLoading: observable,
      handleDownload: observable,

      setStorageReportMode: action,
      setFrom: action,
      setTo: action,
      loadSummary: action,
      fetchStorageData: action,
      setHandleDownload: action,
      totalDays: computed,
    })
  }

  fetchStorageData = async () => {
    this.isLoading = true
    try {
      const result = await exportService.getStorageData(
        this.from!,
        this.to!,
        this.storageReportMode!,
      )
      runInAction(() => {
        this.storageEntries = result
      })
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  setHandleDownload(action?: () => void): void {
    this.handleDownload = action
  }

  setStorageReportMode(storageReportType?: StorageReportMode): void {
    this.storageReportMode = storageReportType
  }

  setFrom(from?: Dayjs): void {
    this.from = from
  }

  setTo(to?: Dayjs): void {
    this.to = to
  }

  loadSummary = async () => {
    const result = await exportService.getNonVesselSummary(
      this.from!,
      this.to!,
      this.storageReportMode!,
    )

    runInAction(() => {
      this.summary = result
    })
  }

  setSummary(dto?: StorageSummaryDto[]): void {
    this.summary = dto ?? []
  }

  public get totalDays(): number {
    return _.sumBy(this.summary, x => _.sumBy(x.containers, c => c.amount))
  }

  public resetData(): void {
    this.setStorageReportMode()
    this.setFrom(undefined)
    this.setTo(undefined)
    this.setSummary()
    this.storageEntries = []
    this.isLoading = false
  }
}
